import { Injectable } from '@angular/core';

/** What the current dealer listings show for a plate page (pounds). */
export interface PlateListingFacts {
  low: number;
  high: number;
  sellers: number;
}

/**
 * Facts a page has already loaded and shows the user, shared with the Plato
 * assistant so his answers match the page (and cost no extra lookups). Only
 * numbers are shared; the assistant server re-validates them.
 */
@Injectable({ providedIn: 'root' })
export class PlatoPageFactsService {
  private listings = new Map<string, PlateListingFacts | null>();

  private key(reg: string): string {
    return (reg || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  }

  setListing(reg: string, facts: PlateListingFacts | null): void {
    this.listings.set(this.key(reg), facts);
  }

  /** undefined = the page hasn't reported yet; null = no current listings. */
  getListing(reg: string): PlateListingFacts | null | undefined {
    return this.listings.get(this.key(reg));
  }
}
